var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import styles from './table.module.scss';
import { Icons } from 'src/ui/components/Icons/Icons';
import { COLORS } from 'src/shared/styles/colors';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import { IDENTIFIER_TABLE, IDENTIFIER_TABLE_CELL, IDENTIFIER_TABLE_ROW } from 'src/ui/components/Table/constants';
import { Fragment } from 'react';
export var Table = function (props) {
    var collection = props.collection, columns = props.columns, currentSort = props.currentSort, onHeadClick = props.onHeadClick, itemRender = props.itemRender;
    var handleHeadClick = function (e, label) {
        e.stopPropagation();
        if (onHeadClick) {
            onHeadClick(label);
        }
    };
    return (_jsx("div", __assign({ "data-test": IDENTIFIER_TABLE, className: styles.tableWrapper }, { children: _jsxs("table", __assign({ className: styles.table }, { children: [_jsx("thead", __assign({ className: styles.tableHeadWrapper }, { children: _jsxs("tr", __assign({ "data-test": IDENTIFIER_TABLE_ROW, className: styles.tableHead }, { children: [columns.map(function (col, index) {
                                var _a, _b;
                                var isSortable = col.sortable !== false && col.keyMapForValue.length === 1;
                                var isCurrentSorted = isSortable && (currentSort === null || currentSort === void 0 ? void 0 : currentSort.field) === col.keyMapForValue[0].source.replace('data.', '');
                                return (_jsx("td", __assign({ "data-test": IDENTIFIER_TABLE_CELL, className: classNames(styles.headCellWrapper, (_a = {}, _a[styles.headCellWrapperSortable] = isSortable, _a)), onClick: isSortable ? function (e) { return handleHeadClick(e, col.label); } : null }, { children: _jsxs("div", __assign({ className: styles.headCell }, { children: [col.label, _jsx(Icons, { icon: E_ICONS.FULL_ARROW_RIGHT, className: classNames(styles.arrowSort, (_b = {},
                                                    _b[styles.sortAsc] = !!(currentSort === null || currentSort === void 0 ? void 0 : currentSort.ascending),
                                                    _b[styles.arrowVisible] = isCurrentSorted,
                                                    _b)), color: COLORS.PRIMARY['500'] })] })) }), "".concat(col.label, "-").concat(index)));
                            }), _jsx("td", { className: styles.headCellWrapper })] })) })), _jsx("tbody", { children: collection.map(function (item) { return (_jsx(Fragment, { children: itemRender(item) }, item.id)); }) })] })) })));
};
